import HCLTreeVertexValue from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import Label from "../../HCLTreeVertexValue/Label";

class EndStateVertexValue extends HCLTreeVertexValue {

  /**
   * @param {Label} label - label for EndStateVertex
   */
  constructor(label?: Label) {
    super(label || new Label("End State", ""));
  }

  clone(): EndStateVertexValue {
    return new EndStateVertexValue(this.label.clone());
  }

}

export default EndStateVertexValue;
